export const CARD_ACCEPTANCE_CATALOG = [
  {
    brand: 'visa',
    label: 'Visa',
    fundingTypes: [
      {
        fundingType: 'credit',
        options: [{ subtype: 'standard', label: 'Credit' }]
      },
      {
        fundingType: 'debit',
        options: [
          { subtype: 'standard', label: 'Debit' },
          { subtype: 'prepaid', label: 'Prepaid' },
          { subtype: 'hsa_fsa', label: 'HSA/FSA' }
        ]
      }
    ]
  },
  {
    brand: 'mastercard',
    label: 'Mastercard',
    fundingTypes: [
      {
        fundingType: 'credit',
        options: [{ subtype: 'standard', label: 'Credit' }]
      },
      {
        fundingType: 'debit',
        options: [
          { subtype: 'standard', label: 'Debit' },
          { subtype: 'prepaid', label: 'Prepaid' },
          { subtype: 'hsa_fsa', label: 'HSA/FSA' }
        ]
      }
    ]
  },
  {
    brand: 'discover',
    label: 'Discover',
    fundingTypes: [
      {
        fundingType: 'credit',
        options: [{ subtype: 'standard', label: 'Credit' }]
      },
      {
        fundingType: 'debit',
        options: [
          { subtype: 'standard', label: 'Debit' },
          { subtype: 'prepaid', label: 'Prepaid' },
          { subtype: 'hsa_fsa', label: 'HSA/FSA' }
        ]
      }
    ]
  },
  {
    brand: 'amex',
    label: 'AMEX',
    fundingTypes: [
      {
        fundingType: 'credit',
        options: [{ subtype: 'standard', label: 'Credit' }]
      },
      {
        fundingType: 'debit',
        options: [{ subtype: 'prepaid', label: 'Prepaid' }]
      }
    ]
  },
];

export const allCardsAllowed = () => ({
  allowed_cards: CARD_ACCEPTANCE_CATALOG.flatMap(({ brand, fundingTypes }) =>
    fundingTypes.map(({ fundingType, options }) => ({
      brand,
      funding_type: fundingType,
      allowed_subtypes: options.map(({ subtype }) => subtype)
    }))
  )
});

export const normalizedCardAcceptance = (cardAcceptance) => {
  if (!cardAcceptance || !Array.isArray(cardAcceptance.allowed_cards)) {
    return allCardsAllowed();
  }

  return {
    allowed_cards: CARD_ACCEPTANCE_CATALOG.flatMap(({ brand, fundingTypes }) =>
      fundingTypes.flatMap(({ fundingType, options }) => {
        const configuredRule = cardAcceptance.allowed_cards.find(
          (entry) =>
            entry?.brand === brand && entry?.funding_type === fundingType
        );
        const allowedSubtypes = options.map(({ subtype }) => subtype).filter((subtype) =>
          configuredRule?.allowed_subtypes?.includes(subtype)
        );

        return allowedSubtypes.length
          ? [
              {
                brand,
                funding_type: fundingType,
                allowed_subtypes: allowedSubtypes
              }
            ]
          : [];
      })
    )
  };
};

export const hasAcceptedCards = (cardAcceptance) =>
  normalizedCardAcceptance(cardAcceptance).allowed_cards.some(
    ({ allowed_subtypes: allowedSubtypes }) => allowedSubtypes.length > 0
  );

export const canEditCardAcceptance = (user) =>
  ['admin', 'support'].includes(String(user?.user_type || '').toLowerCase());
